import React, { useEffect, useRef, useState } from "react";
import IconMobileAppSolution from "../SvgIcons/IconMobileAppSolution";
import IconTallyConnect from "../SvgIcons/IconTallyConnect";
import IconTallyEnterpriseSolution from "../SvgIcons/IconTallyEnterpriseSolution";
import IconTallyIntegrators from "../SvgIcons/IconTallyIntegrators";
import IconTallySales from "../SvgIcons/IconTallySales";
import "./style.css";
import IconOfferBg from "../SvgIcons/IconOfferBg";

export default function WhatWeOffer() {
  const WhatweData = [
    {
      id: 1,
      icon: <IconTallySales />,
      title: "Tally Sales and Service",
      description: "Explore seamless solutions with our Tally Sales and Service Support.",
    },
    {
      id: 2,
      icon: <IconTallyEnterpriseSolution />,
      title: "Tally Enterprise Solution",
      description: "Discover unparalleled solutions with our Tally Enterprise Solution.",
    },
    {
      id: 3,
      icon: <IconTallyIntegrators />,
      title: "Tally Integrator",
      description: "Unlock advanced ERP solutions with our Tally Integration Solutions.",
    },
    {
      id: 4,
      icon: <IconTallyConnect />,
      title: "Tally Connect",
      description:
        "In the era of digital adoption, geographical challenges in the distribution of goods persist. Tally Connect addresses this by seamlessly supporting businesses with diverse needs.",
    },
    {
      id: 5,
      icon: <IconMobileAppSolution />,
      title: "Tally Integrated Mobile App Solution",
      description:
        "Elevate your business with our Tally Integrated Mobile App Solution Partner. Benefit from expert guidance, sales support, and dedicated service for seamless integration.",
    },
  ];
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const currentRef = sectionRef.current;
  
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3,
      }
    );
  
    if (currentRef) {
      observer.observe(currentRef);
    }
  
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);   
  
  return (
    <section
      className={`pb100 pt100 whatweoffer relative overflow-hidden ${
        isVisible ? "draw-active" : ""
      }`}
      ref={sectionRef}
    >
      <div className="bg-svg-wrapper">
        <IconOfferBg />
      </div> 
        <div className="container">
          <div className="whatweoffer-main">
            <div className="titletwo">
              <h2>
                What we <span>offer?</span>
              </h2>
              <p>
                We provide a comprehensive range of Tally-powered solutions
                tailored to meet the evolving needs of modern businesses. From
                seamless software integrations and mobile app solutions to
                expert support and enterprise-level services, our offerings are
                designed to enhance your operational efficiency and drive
                growth.
              </p>
            </div>
            {WhatweData.map((item, index) => (
              <div
                key={item.id}
                className="whatofferBox box-default"
                data-aos="fade-in"
                data-aos-delay={index * 0.1}
              >
                <span>{item.icon}</span>
                <div className="information">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
    </section>
  );
}
